export const addScript = async ({ src, isAsync = true, key, id, crossOrigin = false }) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = isAsync;
    if (crossOrigin) {
      script.crossOrigin = '';
    }
    if (key) {
      script.key = key;
    }
    if (id) {
      script.id = id;
    }

    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error(`Failed to load script: ${src}`));
    };

    document.body.appendChild(script);
  });
};

export const addStylesheet = async ({ href, key, id, crossOrigin = false }) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.href = href;
    link.rel = 'stylesheet';
    if (crossOrigin) {
      link.crossOrigin = '';
    }
    if (key) {
      link.key = key;
    }
    if (id) {
      link.id = id;
    }
    document.head.appendChild(link);
    link.onload = () => {
      resolve();
    };
    link.onerror = () => {
      reject(new Error(`Failed to load stylesheet: ${href}`));
    };
  });
};
